import { HydrateWidgetFn } from '@framework/engine';
import { get } from 'lodash';
import { IUploadWidget } from './IUploadWidget';
import { uploadWidgetFilenameField } from './createUploadWidgetFormSchema';

export const hydrateUploadWidget: HydrateWidgetFn<IUploadWidget> = ({
  context,
  path,
}) => {
  const value = get(context.values, path);
  const filename = get(context.values, uploadWidgetFilenameField(path));

  return {
    value: value ?? undefined,
    filename: filename ?? undefined,
  };
};
